var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrograms = function SvgPrograms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 7.333H12l-2 6-4-12-2 6H1.333",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgPrograms as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M14.6668 7.33301H12.0002L10.0002 13.333L6.00016 1.33301L4.00016 7.33301H1.3335' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";